/* =========================================================================
   CHARMANTE — Favoris (liste de souhaits, stockée dans le navigateur)
   - Cœur ♡ sur les produits pour ajouter/retirer
   - Page « Mes favoris » (#favoris-list) qui réaffiche les produits choisis
   - Bouton « Ajouter au panier » depuis les favoris
   ========================================================================= */
(function () {
  'use strict';
  var C = (window.Charmante = window.Charmante || {});
  var KEY = 'charmante_favoris';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} updateBadge(list); }
  function has(h) { return read().some(function (f) { return f.handle === h; }); }

  function updateBadge(list) {
    list = list || read();
    var b = document.querySelector('[data-fav-count]');
    if (b) { b.textContent = list.length; b.style.display = list.length ? '' : 'none'; }
  }
  function markAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.fav-btn[data-handle]'), function (b) {
      b.classList.toggle('is-fav', has(b.getAttribute('data-handle')));
    });
  }

  /* ---- clic sur un cœur : ajoute/retire des favoris ---- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.fav-btn'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-handle'); if (!h) return;
    var list = read(), i = -1;
    for (var k = 0; k < list.length; k++) { if (list[k].handle === h) { i = k; break; } }
    if (i >= 0) { list.splice(i, 1); }
    else {
      list.unshift({ handle: h, title: b.getAttribute('data-title'), image: b.getAttribute('data-image'),
        price: b.getAttribute('data-price'), url: b.getAttribute('data-url'), vid: b.getAttribute('data-vid') });
    }
    write(list); markAll(); renderFavPage();
    if (typeof C.toast === 'function') C.toast(i >= 0 ? 'Retiré des favoris' : 'Ajouté aux favoris 💗');
  });

  /* ---- page « Mes favoris » ---- */
  function renderFavPage() {
    var wrap = document.getElementById('favoris-list'); if (!wrap) return;
    var list = read();
    var empty = document.getElementById('favoris-empty');
    if (empty) empty.style.display = list.length ? 'none' : '';
    wrap.innerHTML = list.map(function (f) {
      return '<div class="favcard">'
        + '<a class="favcard__media" href="' + f.url + '" style="background-image:url(' + (f.image || '') + ')" aria-label="' + (f.title || '') + '"></a>'
        + '<button class="favcard__rm" type="button" data-handle="' + f.handle + '" aria-label="Retirer des favoris">✕</button>'
        + '<div class="favcard__info"><a href="' + f.url + '" class="favcard__name">' + (f.title || '') + '</a><span class="favcard__price">' + (f.price || '') + '</span></div>'
        + '<button class="btn btn--rose favcard__add" type="button" data-vid="' + (f.vid || '') + '">Ajouter au panier</button>'
        + '</div>';
    }).join('');
  }

  /* ---- retirer un favori depuis la page favoris ---- */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.favcard__rm'); if (!rm) return;
    e.preventDefault();
    var h = rm.getAttribute('data-handle');
    write(read().filter(function (f) { return f.handle !== h; }));
    markAll(); renderFavPage();
  });

  /* ---- ajouter au panier depuis les favoris ---- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.favcard__add'); if (!a) return;
    var vid = a.getAttribute('data-vid'); if (!vid) return;
    a.disabled = true;
    // feedback instantané
    if (typeof C.flyToCart === 'function') C.flyToCart(a);
    if (typeof C.toast === 'function') C.toast('Ajouté au panier ✨');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: Number(vid), quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () { if (C.cart && C.cart.refresh) C.cart.refresh(); })
      .catch(function () { if (typeof C.toast === 'function') C.toast('Oups, réessaie 🙈'); })
      .then(function () { a.disabled = false; });
  });

  function init() { markAll(); updateBadge(); renderFavPage(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
